module.exports = __webpack_public_path__ + "img/icon-ticket-lotto.1a7ad88b.svg";